import React, { ReactElement, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { requestLogin } from '../../../api/login/login.actions';
import { requestDeleteAccount } from '../../../api/system-user/system-user.actions';

import DeleteAccount from '../../../components/screens/auth/delete-account/DeleteAccount';

const DeleteAccountContainer = (): ReactElement => {
  const [accountDeleted, setAccountDeleted] = useState<boolean>(false);

  const dispatch: Dispatch = useDispatch();

  const handleDeleteAccountClick = (email: string, password: string): void => {
    dispatch(
      // @ts-expect-error TODO: Fix after addting types to login actions
      requestLogin({
        input: { email, password },
        deleteAccount: true,
        onSuccess: (): void => {
          dispatch(
            // @ts-expect-error TODO: Fix after addting types to system user actions
            requestDeleteAccount({
              onSuccess: (): void => setAccountDeleted(true)
            })
          );
        }
      })
    );
  };

  return <DeleteAccount accountDeleted={accountDeleted} handleDeleteAccountClick={handleDeleteAccountClick} />;
};

export default DeleteAccountContainer;
